import { TFormValues, TRequestValues } from '../../../types/requestDemand';
import { ERequestDemandField } from '../../../constants/requestDemand';

export const fromFormFieldToValues = (formValue: TFormValues): TRequestValues => ({
  [ERequestDemandField.PHONE]: formValue[ERequestDemandField.PHONE].value,
  [ERequestDemandField.EMAIL]: formValue[ERequestDemandField.EMAIL].value,
  [ERequestDemandField.USER_TYPE]: formValue[ERequestDemandField.USER_TYPE].value,
});
